export default {
  accountValidateMsg: "アカウントの長さは6-30文字。英数字、記号（＠/_/.)を使用でき、イニシャルは英数字のみです。",
  storeSuccess: "チャージ成功",
  editAccountTips: "有効なアカウントを入力してください",
  editPwdTips: "有効なパスワードを入力してください",
  editRepeatPwdTips: "パスワードを再入力してください",
  pwdRepeatTips: "入力パスワードが一致しません",
  changePwdSucc: "パスワード修正成功",
  bindEmail: "メールバインド",
  errorVrifyCodeTips: "検証コードエラー",
  slectQuessionTips: "セキュリティ質問を選択してください",
  answerTips: "解答を入力してください",
  twoAnswerTips: "セキュリティ質問を二つ選択し、解答してください。",
  realNameValidateTips: "4~60文字の本名を入力してください",
  phoneValidateTips: "6～18桁の電話番号を入力してください",
  areaSelectTips: "正確な国家及び地区を入力してください",
  iDCardValidataTips: "1~60位のマイナンバーを入力してください",
  changeProfileSucc: "編集成功",
  editVrfCodeTips: "検証コードを入力してください",
  securityQuestionTips: "安全性向上の為にセキュリティ質問を設定してください。パスワードを忘れた際に、セキュリティ質問を利用して再設定できます。",
  validateQuessionTips: "異なる質問を二つ選択し、認証を完了すると、セキュリティ質問を再設定できます。",
  originPwd: "旧パスワードを入力してください",
  newPwd: "新パスワードを入力してください",
  changePwdSuccess: "パスワードの修正に成功しました。データ保護の為に、もう一度ログインしてください",
  accountName: "アカウント名を入力してください",
  password: "パスワードを入力してください",
  repeatPassword: "パスワードを再入力してください",
  findPwdTips: "ご登録済みのアカウントを入力してください",
  submit: "提出",
  send: "送信",
  modify: "修正",
  haveAgree: "同意する",
  and: "及び",
  privacyPolicy: "プライバシーポリシー",
  completeness: "資料完成度：",
  gender: "性別",
  male: "男",
  female: "女",
  birthday: "生年月日",
  phone: "電話番号",
  region: "国/地区",
  ID: "パスポートナンバー或いはマイナンバー",
  accountSetting: "アカウント設定",
  upgrade: "アカウントランクアップ",
  profile: "プロフィール",
  changePassword: "パスワード変更",
  securityQuestion: "セキュリティ質問",
  creatework_headerTitle: "オーダー作成",
  mylist_headerTitle: "マイオーダー",
  bindEmailTips: "お使いのメールアドレスを設定し、セキュリティレベルをアップします。パスワードをお忘れの場合、メールアドレスで簡単にパスワードを再設定できます。",
  enterEmailVrfcationTips: "届いた認証コードを入力してください",
  cancel: "キャンセル",
  bindTps: "アカウント連携すると複数のデバイスでゲームをプレイできます！",
  login: "ログイン",
  logout: "ログアウト",
  bind: "アカウント連携",
  feedback: "フィードバック",
  terms: "関連規約",
  tips: "ヒント",
  guestSwitchTips: "ログイン後ゲストアカウント情報は消失しますが、よろしいですか？",
  register: "登録",
  realName: "実名",
  enterEmailTips: "メールアドレスを入力してください",
  emailVAlidateMsg: "メールアドレスフォーマットエラー",
  editEmaileTips: "メールアドレスを入力してください",
  checkServiceTips: "利用規約とプライバシーポリシーを閲覧後承認してください！",
  brithdayValidateTips: "正確な誕生日を選択してください",
  facebookValidateTips: "1~60文字のfacebookアカウントを入力してください",
  eritOriginPwdTips: "元のパスワードを入力してください",
  submitSuccess: "申請成功",
  rebindEmail: "メールアドレス変更",
  bindEmailSuccess: "メールアドレス$email</br>と関連付けしました。関連付けされたメールアドレスの認証後、メールアドレスを再設定できます。",
  reSetSecurityQuessoon: "セキュリティ質問<br/><br/>を設定しました。それぞれの質問の認証後、質問を再設定できます。",
  canotModifyTips: "プロフィール情報は提出後変更できませんが、よろしいですか？",
  rebindEmailTips: "メールアドレス$emailに届いた認証コードを入力してください",
  reGetVrfCode: "認証コード取得",
  findPwdWayTips: "下記の方法で取り戻します",
  emailWay: "メールアドレスで取り戻します",
  emailWayTips: "届いた認証メールでパスワードを再設定できます。",
  quessionWay: "セキュリティ質問で取り戻します",
  quessionWayTips: "セキュリティ質問に解答し、パスワードを再設定できます。",
  resetPwdBtn: "パスワード再設定",
  lastStep: "前へ",
  sendEmailTips: "認証メールアドレス$emailにメールを送信しました。<br>届いた認証コードを正しく入力してください。",
  setNewPwdTips: "おめでとうございます！<br>パスワードを再設定できるようになりました。メッセージ欄に新パスワードを入力してください！",
  termsOfUse: "利用規約",
  copy_success: "コピーしました",
  creatework_create: "オーダー",
  creatework_createHolder: "ジャンル選択",
  creatework_title: "タイトル",
  creatework_titleHolder: "タイトル入力",
  creatework_detail: "ご質問の詳細",
  creatework_detailHolder: "200文字以内で入力してください",
  creatework_uploadTips: "jpg/pngファイルしかアップできません。ファイルサイズの上限は5MBです",
  creatework_selectBox_selectTile: "ジャンル",
  creatework_goGame: "ゲームに戻る",
  creatework_history: "オーダー履歴",
  mylist_noYet: "まだ何もありませんよ",
  mywork_solved: "問題解決？クリックしてね",
  mywork_service: "評価",
  mywork_messageHolder: "入力してください",
  mywork_score: "評価してください",
  mywork_confirm: "確認",
  creatework_selectBox_selectList3: "その他の問題",
  creatework_selectBox_selectList2: "アカウント問題",
  creatework_gameHolder: "ゲームを選択してください",
  creatework_serverHolder: "サーバーを選択してください",
  contactService: "お問い合わせ（タップ）",
  FAQ: "FAQ",
  creatework_game: "ゲーム：",
  creatework_server: "サーバー：",
  creatework_role: "キャラクター：",
  selectRoleName: "キャラクター選択",
  creatework_noRole: "キャラクター未作成",
  creatework_noGame: "ゲームリストに何もありません",
  creatework_noServer: "サーバーリストに何もありません",
  termText: "{mainHost}のを同意します。",
  backLogin: "ログインに戻る",
  creatework_roleHolder: "キャラクターを選択した後、再び訪問してください。",
  findPwdFailTips: "セキュリティ質問及びメールバインドを設定していません。global.support@37games.comにお問い合わせください",
  payMall: "課金商店",
  selectPayment: "金額選択",
  plzSelectPayWay: "支払方法の選択",
  gainPlus: "リベート",
  gainMorePlus: "ハイリベート",
  gainMostPlus: "MAXリベート",
  plzSelectPayType: "課金方法選択",
  roleName: "キャラクター名",
  payWay: "支払方法",
  plzSelectOtherWay: "他の支払方法",
  payment: "支払金額",
  compensateTips: "商品価値をオーバーする部分は補償として、$gameCodeをお送りします",
  extaGain: "追加獲得",
  gameGold: "ゲーム内通貨",
  compensate: "補償",
  payWayPlus: "ルート返金率",
  neddPay: "お支払い金額",
  submitOrder: "お支払い",
  screenshotTips: "ヒント：オーダー情報をスクリーンショットして保存してください。問題が発生する場合、スクリーンショットを使ってご連絡ください。",
  storeFail: "チャージを完了できませんでした",
  storeFailTips: "チャージ失敗。リトライしてください。ご不明点はカスタマーセンターにお問い合わせください",
  storeAcceptance: "処理中",
  storeSuccessTips: "お取引後、15分以内にチャージされますので、ご確認ください",
  orderNumber: "オーダー番号",
  buyProduct: "アイテム",
  transactionAmount: "取引金額",
  failReason: "失敗原因",
  payOntherORder: "再チャージ",
  reStore: "リトライ",
  confirm: "確認",
  switch: "アカウントの切り替え",
  completeTips:
    '個人情報をご記入ください。下記の情報<mark class="yellowMarkColor">をご記入した後、修正できません</mark>。アカウントが紛失したり、盗用されたりする場合、正確な個人資料をご提供いただければ、アカウントを取り戻す事が可能です。',
  creatework_selectBox_selectList0: "ゲーム問題",
  creatework_selectBox_selectList1: "支給問題",
  creatework_selectBox_selectList4: "翻訳問題",
  mywork_solvedText: "問題は解決済み",
  browserPayErrBtnText: "取引エラー",
  browserPaySucBtnText: "支払終了",
  browserPayingTips: "支払いページへ向かいます。<br/>支払い終了後にこのページを閉じてください。",
  price_list_empty: "選択可能金額がありません",
  pointCardTips: "ヒント：$paymentAmountでの購入しかサポートできません",
  forgetPwd: "パスワードを忘れた",
  payCenter: "チャージセンター",
  willGet: "獲得内容",
  goods: "商品",
  discount: "おまけ",
  payDiscount: "オーバー補償",
  payDiscountTips: "商品価格を超えた分の補償です",
  hasQuestionPlease: "質問等ありましたら、",
  pwdValidateMsg: "半角6-20字以内",
  payWayPlusC: "チャンネルボーナス",
  fwtk: "利用規約",
  yszc: "プライバシーポリシー",
  exchange: "ギフトコード交換",
  remember: "ログインしたままにする",
  thirdInfo: "アカウント規則",
  thirdInfoContent: "ゲーム内のユーザーセンターでアカウントをバンディングしてからログインしてください。",
  unLink: "サポートされていない方法です",
  favour: "お気に入り",
  goStoreTip: "チャージ画面へお進みください",
  go: "進む",
  otherLogin: "その他の方法",
  qrCodeTip: "QRコードをスキャン<br/>してください",
  favourTip: "お気に入りに保存すると、次回スムーズにスタートできます",
  share: "フレンドにシェア",
  landscapeTip: "画面を縦にして操作してください",
  leaveTip: "ゲームを終了しますか？",
  selectRole: "キャラクターを選んでください",
  selectMoney: "購入する道具を選んでください。",
  seletGameInfoFirst: "ゲームを選んでください",
  lowerIE: "申し訳ございません。IE11以下のブラウザには対応しておりません。ブラウザを更新していただくか、下記QRコードよりアプリをダウンロードしてお楽しみください。",
  linkTermText: "{mainHost}の[利用規約]及び[プライバシーポリシー]を同意します",
  download: "ダウンロード",
  favourAndDownloadTip: "旦那様、ブックマーク登録又はダウンロードしてくださいまし(✿◡‿◡)<br/>次回もお会いしとうございます",
  payReward: "",
  hasEqualReward: "",
  payBtnText: "",
  storeHoaveReward: "",
  showMorePayWay: "",
  needPaymentCount: "",
  orderDetail: "",
  selectPayWayPlz: "",
  countryCode: "国番号",
  deleteaccount_title1: "アカウント削除",
  deleteaccount_title2: "削除申請",
  deleteaccount_step1_1:
    "アカウントの削除を申請すると、14日間アカウントが凍結されます。14日間が過ぎるとアカウントが永久に削除されます。アカウントが削除されてからはSNSなどのコミュニティーへのログインもできなくなります。",
  deleteaccount_step1_2: "凍結期間中は以下のリンク先でアカウント削除を取り消すことができます。",
  deleteaccount_step1_3: "アカウントが削除されるとすべてのデータがなくなり、二度と復旧できなくなります。",
  deleteaccount_step1_4: "よろしいでしょうか？",
  deleteaccount_step2_1: "アカウントおよびすべてのゲームキャラクターのデータを削除しますか？",
  deleteaccount_step2_2: "「Delete」を入力すると実行されます",
  deleteaccount_step3: "アカウントの完全なる削除は申請14日後となります。",
  accountrecovery_note: "注意：",
  accountrecovery_tips: "アカウントの復旧は凍結期間中にしかできません。",
  accountrecovery_Submitted2: "アカウントの復旧申請を行いました。アカウントおよびキャラクターの削除申請が取り消されます。",
  accountrecovery_Failed: "申請失敗",
  accountrecovery_Failed_1: "対象のアカウントは正常であり、通常通りログインできます。",
  accountrecovery_Failed_2: "キャラクターデータが見つかりません。\n再入力してください。",
  accountrecovery_success: "アカウントが復旧されました",
  account_normal: "アカウント正常、復旧できません",
  account_unablerestore: "アカウントなし、復旧できません",
  accountrecovery_roleHolder: "キャラクターネーム",
  accountrecovery_headerTitle: "アカウント削除の撤回",
  guideTitle: "",
  accountFix: "",
  inputAccount: "",
  applyForAccountFix: "",
  nonEnterItem: "",
  resetOT: "",
  addOT: "",
  errorPwd: "",
  verifyAccount: "",
  selectRegisterTime: "",
  enterBindEmail: "",
  enterUsedPhoneType: "",
  enterIdfaGpid: "",
  enterContactEmail: "",
  confirmTermsPrivacy: "",
  enterRechargeRemark: "",
  uploadImg: "",
  selectIDType: "",
  enterIDNum: "",
  enterIP: "",
  enterQueryNum: "",
  enterQueryPwd: "",
  errorQueryItem: "",
  enterPassword: "",
  enterPasswordAgain: "",
  enterPasswordNonSame: "",
  enterEmail: "",
  sendSuccess: "",
  enterCode: "",
  errorCode: "",
  selectQuest: "",
  enterAnswer: "",
  selectDifferQuest: "",
  addSuccess: "",
  picFormt: "",
  countdownBefore: "",
  countdownAfter: "",
  uploadDone: "",
  uploadFail: "",
  applySuccess: "",
  applyFailed: "",
  resetQuestAlterFailed: "",
  resetQuestError: "",
  resetQuestNone: "",
  resetQuestAltered: "",
  illegalOperation: "",
  queryNotExist: "",
  queryPasswordError: "",
  auditing: "",
  notPass: "",
  suppleInformation: "",
  suppleInformationUnHandle: "",
  suppleInformationTimeout: "",
  repairedAccountSuccess: "",
  repairedAccountLost: "",
  loginStateNone: "",
  repairedAccountTimeout: "",
  changePasswordSucc: "",
  emailSendFailed: "",
  emailSendLimit: "",
  repairedAccountTimeout2: "",
  emailCodeSended: "",
  alterSuccess: "",
  questionAlterSuccess: "",
  username: "",
  code: "",
  selectServiceType: "",
  submitForm: "",
  apply: "",
  reviewApplicationStatus: "",
  instantReviewOfTheStatus: "",
  reviewStatus: "",
  backToLogin: "",
  previous: "",
  applyDesc: "",
  additionalServices: "",
  resetSecurityEmail: "",
  resetSecurityQuest: "",
  registrationDate: "",
  month: "",
  year: "",
  emailBound: "",
  modelNumber: "",
  deviceName: "",
  provideRecharge: "",
  selectCountry: "",
  passportID: "",
  upload: "",
  del: "",
  pleaseUpload: "",
  uploadAgain: "",
  enterDesc: "",
  contactEmail: "",
  applyNoteAttr: "",
  applyNoteDate: "",
  agree: "",
  UJOYTerms: "",
  privacy: "",
  reviewStatusOfAccountFix: "",
  enterReviewID: "",
  enterReviewPwd: "",
  review: "",
  reviewNoteAttr: "",
  reviewNoteData: "",
  haveResetInfo: "",
  resetProfile: "",
  desc: "",
  changePwd: "",
  resetPwd: "",
  reset: "",
  enterNewPwd: "",
  confirmNewPwd: "",
  successResetPwd: "",
  bindSecurityEmail: "",
  resetPwdDesc: "",
  bindCommon: "",
  sendCommon: "",
  enterVcode: "",
  successResetEmail: "",
  resetQuest: "",
  resetQuestDesc: "",
  successResetQuest: "",
  hide: "",
  addRegisterTime: "",
  modelNum: "",
  registrationIP: "",
  addRechargeRecord: "",
  serviceReply: "",
  addDataLimitTime: "",
  addMoreInfo: "",
  applicationSubmit: "",
  underReviewStatus: "",
  reviewID: "",
  reviePwd: "",
  enterReviewIDNPwd: "",
  homepage: "",
  checkEmailAttr: "",
  checkEmailData: "",
  underReview: "",
  underReviewReply: "",
  failed: "",
  reason: "",
  underReviewAdd: "",
  addInfoRequired: "",
  dateForAddInfo: "",
  addInfo: "",
  addInfoSubmit: "",
  hasBeenRepaired: "",
  opExpired: "",
  approved: "",
  haveSubmitted: "",
  sessionExpired: "",
  submitted: "",
  addItemRegisterDate: "",
  addItemDeviceNumber: "",
  reasonItemPwd: "",
  addItemIDPhoto: "",
  idfaTitle: "",
  idfaSubTitle1: "",
  idfaSubTitle1Desc1: "",
  idfaSubTitle1Desc2: "",
  idfaSubTitle2: "",
  idfaSubTitle2Desc1: "",
  idfaSubTitle2Desc2: "",
  idfaSubTitle2Desc3: "",
  uploadIDCard: "",
  uploadTipsBefore: "",
  uploadTipsAfter: "",
  submitError: "",
  applyLimitError: "",
  applyDisabled: "",
  inputDataError: "",
  dataException: "",
  picSizeLimit: "",
  picTypeLimit: "",
  picNull: "",
  alteredPassword: "",
  inputError: "",
  pwdChangefailed: "",
  sendEmailCodeDisabled: "",
  alteredEmail: "",
  inputEmailError: "",
  operationFailed: "",
  codeNull: "",
  findPwd: "パスワードを忘れた場合",
  findAccountAndPwd: "アカウントを忘れた場合",
  usualDeviceNum: "",
  usualPhoneNum: "",
  registerTimeError: "",
  bindEMailError: "",
  rechargeRecordError: "",
  registerIPError: "",
  deviceNumError: "",
  deviceModelError: "",
  confirmTerms: "",
  applyFixAccount: "上記の方法で確認できない場合は、アカウントの修復を申請してください",
  findPwdByFixAccount: "サポートメールが設定されておりません。アカウント修復よりパスワードの再発行ができます。",
  h5_favour_has_gift: "お気に入りの報酬が届きました、メールでお受け取り下さい。",
  h5_favour_get_gift: "お気に入りに追加すると、報酬がもらえますよ～",
  h5_get_gift_fault: "受領失敗、リトライするかカスタマー・サービスよりお問い合わせください。",
  h5_favour_please_select: "",
  h5_favour_login_get: "報酬が確実に届くように、まずログインしてキャラクターを作成してください～",
  h5_favour_tip: "どうぞメールでお受け取り下さい～",
  h5_favour_select_serve: "",
  h5_favour_select_role: "",
  store_product_paytype_error: "購入できません。別の支払い方法でもう一回購入してください",
  SwitchWithThirdWay: "${type}でサインイン",
  moreGame: "その他のゲーム",
  serviceTitle: "カスタマーサービス",
  h5_download_login: "報酬が確実に届くように、まずログインしてキャラクターを作成してください～",
  h5_download_tips: "",
  h5_download_repeat_get: "ダウンロードの報酬が届きました、メールでお受け取り下さい。",
  h5_download_succ: "ダウンロードをすると、報酬がもらえますよ～",
  h5_download_repeat_role: "",
  currentLoginAccount: "ログインアカウント：",
  fb_canvas_fullscreen: "fullｽｸﾘｰﾝ",
  fb_canvas_website: "HP",
  fb_canvas_like_share: "ｼｪｱ",
  fb_canvas_service: "CS",
  fb_canvas_login_fail: "ログイン失敗",
  fb_canvas_pay_return: "キャンセルしました",
  fb_canvas_root_tip: "Facebookへのログインを許可してください",
  h5_popup_title: "お支払い",
  h5_popup_submit: "お支払い",
  h5_popup_last_used: "前回使用",
  h5_popup_quit_tips: "お支払をキャンセルしますか？",
  h5_popup_quit_check: "YES",
  h5_popup_quit_cancel: "NO",
  h5_popup_currency_sign: "円",
  h5_popup_product_empty: "製品情報はまだ取得されていません。更新してください",
  h5_popup_server_empty: "サーバーリストはまだありません。更新してください",
  aboutRelevanceAccount: "アカウントの連携について",
  selectLoginType: "ログインする方法を選んでください",
  touristDescription: "◆ WEBとアプリとの外部サービス認証（Facebook、Twitter、Google Play）の種類が異なることがございます。",
  touristSuggest: "◆ 外部サービス認証でアプリと連携できない場合は、引き継ぎコードで連携をお行いください。",
  h5_tourist_remenber: "14日間この選択を記憶する",
  account_czsm1: "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
  account_czsm2: "2、引き継ぐ時のパスワードを登録してください。",
  account_czsm3: "3、セキュリティ保護のため、",
  account_wzfdmm: "大文字と小文字を区別して、6-16文字のパスワードをご入力",
  account_qzcsrmm: "再度パスワードをご入力",
  account_fxyjm: "引き継ぎコード発行",
  account_yjmsm1: "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
  account_yjmsm2: "2、引き継ぎナンバーに使用期限はございません。",
  account_yjmsm3: "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
  account_yjmsm4: "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
  account_fz: "コピー",
  account_cxfx: "新規で発行する",
  account_czsm4: "アカウントを連携",
  account_czsm5: "してください。",
  account_yjm: "引き継ぎコード",
  account_16wzzj: "パスワードの長さは6～16文字にする",
  account_qsrzqdyjmhmm: "正しい引き継ぎコードとパスワードを入力してください。",
  account_yj: "引き継ぎ",
  accoun_lcsrdmmbyz: "パスワードの両回の入力は一致しない",
  deleteaccount_step3_1: "から申請を取り消すことができます。申請を取り消しますか？",
  account_syyjm: "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
  account_yjmznsyyc: "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
  account_sryjm: "引き継ぎコードを入力",
  account_srmm: "パスワードを入力",
  h5_header_gift: "ギフト",
  h5_award_popup_type: "報酬",
  h5_award_popup_content: "アイテム",
  h5_award_popup_code: "ギフト交換コード",
  h5_favour_gift_name: "フォローギフト",
  h5_download_gift_name: "ダウンロードギフト",
  h5_award_popup_exchange_way: "交換方法：ゲームのメイン画面の右下→もっと→交換コード",
  h5_succ_get_gift: "ギフト交換コードを手に入れました",
  h5_exchange_info_title: "交換方法",
  h5_exchange_info_1: "交換方法：ゲームのメイン画面の右下→もっと→交換コード",
  h5_exchange_info_2: "一つのアカウントは「ダウンロードギフト」を1回だけ交換できる",
  h5_check_gift: "報酬確認",
  account_delete_scdqzh: "アカウント及びゲームデータを削除してもよろしいですか？",
  account_delete_fwq: "サーバー",
  account_delete_zhm: "キャラクター",
  account_delete_jshflj: "キャラクターを忘れた場合",
  account_delete_qzyzmdxx: "大文字と小文字を区別してください",
  account_delete_jtbcysxx: "スクリーンショットに保存し、大切に保管してください！！！",
  deleteaccount_step3_2: "アカウントが完全に削除された場合、すべてのデータが二度と復旧できなくなります。\n\n申請から14日間以内に",
  h5_guest_login: "ゲストログイン",
  h5_click_copy: "",
  questionnaire_btn: "アンケート調査",
  "-": "-",
};
